<template>
  <v-container fluid
               class="pa-0"
               v-if="AddedFields">
    <component v-for="field in FilteredFieldList"
               :key="field.Label"
               :is="parseType(field.Type)"
               :label="field.Label"
               :value="!isNew ? getValueFromKeychain(sourceObject, field.Valuekey) : field.DefaultValue"
               :keyname="field.Valuekey"
               :rules="field.Rules"
               :edit="editMode && field.Editable"
               @fetch="passupdate" />
  </v-container>
</template>


<script>
import EditLi from "@/components/Inputs/EditableListItem.vue";
import SwitchLi from "@/components/Inputs/SwitchListItem.vue";
import AddressLi from "@/components/Inputs/AdressListItem.vue";
import AreaLi from "@/components/Inputs/AreaListItem.vue";
import DateLi from "@/components/Inputs/DateListItem.vue";

import KeyDiverMixin from "@/helpers/Mixins/KeyDiverMixin";

export default {
  name: "FieldPrinter",
  props: {
    sourceObject: Object,
    fieldList: Array,
    groupRestriction: String,
    editMode: Boolean,
    isNew: Boolean,
  },
  components: { EditLi, SwitchLi, AddressLi, AreaLi, DateLi },
  mixins: [KeyDiverMixin],

  data() {
    return {};
  },

  methods: {
    parseType(type) {
      var component;
      switch (type) {
        case "input":
          component = EditLi;
          break;
        case "area":
          component = AreaLi;
          break;
        case "address":
          component = AddressLi;
          break;
        case "date":
          component = DateLi;
          break;
        case "switch":
          component = SwitchLi;
          break;
        default:
          component = EditLi;
      }
      return component;
    },

    passupdate(update) {
      
      this.$emit("fetch", update);
    },
  },

  computed: {
    FilteredFieldList() {
      if (!this.fieldList) {
        return [];
      }
      var group = this.groupRestriction;
      if (group) {
        var filteredlist = this.fieldList.filter(function (x) {
          return x.ContextGroup === group;
        });
        return filteredlist;
      } else {
        return this.fieldList;
      }
    },
  },

  watch: {},
};
</script>


<style lang='scss' scoped>
</style>